import React from 'react';
import { Navigate } from 'react-router-dom';
import LocalStorage from '../../helpers/localstorage';


// Função para verificar se o usuário está autenticado
function isAuthenticated(): boolean {
  const storage = new LocalStorage();
  return storage.getAuthToken() !== null; // Verifica se o token existe
}

// Definindo explicitamente as propriedades, incluindo 'children'
interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // Verifica se o usuário está autenticado
  if (!isAuthenticated()) {
    // Se não estiver autenticado, redireciona para a página de login
    return <Navigate to="/" />;
  }

  // Caso contrário, exibe o conteúdo da página protegida
  return <>{children}</>;
};

export default ProtectedRoute;
